const TradeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
    <path
      d="M4.6 8.17998C6.58823 8.17998 8.2 6.56821 8.2 4.57998C8.2 2.59176 6.58823 0.97998 4.6 0.97998C2.61177 0.97998 1 2.59176 1 4.57998C1 6.56821 2.61177 8.17998 4.6 8.17998Z"
      stroke={"currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.16737 5.04108C9.64404 4.50294 11.2991 4.98495 12.256 6.2318C13.2128 7.47865 13.2502 9.2021 12.3483 10.4893C11.4464 11.7764 9.8138 12.3297 8.31518 11.8561C6.81656 11.3825 5.7984 9.99147 5.8 8.4198C5.80115 8.26551 5.81206 8.11144 5.83265 7.95852"
      stroke={"currentColor"}
      strokeLinejoin="round"
    />
    <path
      d="M13 2.8999L12.04 4.3399L11.08 2.8999"
      stroke={"currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.2 0.5H10.12C11.1804 0.5 12.04 1.35961 12.04 2.42V4.34"
      stroke={"currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 10.1002L1.96 8.66016L2.92 10.1002"
      stroke={"currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.79998 12.5002H3.87998C2.8196 12.5002 1.95998 11.6405 1.95998 10.5802V8.66016"
      stroke={"currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.44511 3.52979H5.01999C5.31001 3.52979 5.54511 3.76489 5.54511 4.05491C5.54511 4.34492 5.31001 4.58003 5.01999 4.58003"
      stroke={"currentColor"}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.44511 5.63007H5.22975C5.51977 5.63007 5.75487 5.39497 5.75487 5.10495C5.75487 4.81494 5.51977 4.57983 5.22975 4.57983H3.86511"
      stroke={"currentColor"}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.86465 3.53027V5.63027"
      stroke={"currentColor"}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.02065 3.53014V2.8999"
      stroke={"currentColor"}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.96767 3.53014V2.8999"
      stroke={"currentColor"}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.02065 6.25989V5.63013"
      stroke={"currentColor"}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.96767 6.25989V5.63013"
      stroke={"currentColor"}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2011 7.37304H9.13314C8.94235 7.36727 8.76353 7.46575 8.66643 7.63008C8.56933 7.79441 8.56933 7.99856 8.66643 8.16289C8.76353 8.32722 8.94235 8.4257 9.13314 8.41992H9.6669C9.85768 8.41415 10.0365 8.51263 10.1336 8.67696C10.2307 8.84129 10.2307 9.04544 10.1336 9.20977C10.0365 9.3741 9.85768 9.47258 9.6669 9.4668H8.5989"
      stroke={"currentColor"}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.4 6.73999V7.37311"
      stroke={"currentColor"}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.4 9.4668V10.0999"
      stroke={"currentColor"}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TradeIcon;
